import { render, staticRenderFns } from "./ProductSkusManager.vue?vue&type=template&id=2c14a745&scoped=true"
import script from "./ProductSkusManager.vue?vue&type=script&lang=js"
export * from "./ProductSkusManager.vue?vue&type=script&lang=js"
import style0 from "./ProductSkusManager.vue?vue&type=style&index=0&id=2c14a745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14a745",
  null
  
)

export default component.exports